import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Award, ChevronRight } from "lucide-react";
import AchievementBadge from "@/components/badges/AchievementBadge";
import NextBadgeGoal from "@/components/badges/NextBadgeGoal";
import { COACH_BADGE_CATEGORIES, showBadgeUnlocks } from "@/lib/badges";
import { toast } from "sonner";

export default function CoachBadgesPanel() {
  const [data, setData] = useState(null);

  const load = () => {
    api.get("/badges").then((r) => setData(r.data)).catch(() => {});
  };

  useEffect(() => {
    load();
    api.get("/badges/unseen")
      .then((r) => {
        const unseen = r.data?.badges || [];
        if (unseen.length > 0) {
          showBadgeUnlocks(unseen, toast);
          api.post("/badges/mark-seen", { badge_codes: unseen.map((b) => b.badge_code) }).catch(() => {});
          load();
        }
      })
      .catch(() => {});
  }, []);

  if (!data) return null;

  const recent = (data.earned || []).slice(0, 3);
  return (
    <Card className="border-slate-100" data-testid="coach-badges-panel">
      <CardContent className="p-5">
        <div className="flex items-center justify-between gap-3 mb-4">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center">
              <Award className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Mes badges coach</h3>
              <p className="text-xs text-slate-500">
                {data.stats?.earned_count || 0} / {data.stats?.total_count || 0} débloqués
              </p>
            </div>
          </div>
          <Button asChild variant="ghost" size="sm" className="text-blue-600 gap-1">
            <Link to="/coach/badges">Voir tout <ChevronRight className="w-4 h-4" /></Link>
          </Button>
        </div>

        {recent.length > 0 ? (
          <div className="flex justify-center gap-6 flex-wrap">
            {recent.map((badge) => (
              <AchievementBadge
                key={badge.badge_code}
                title={badge.title}
                description={badge.description}
                icon={badge.icon}
                category={badge.category}
                categories={COACH_BADGE_CATEGORIES}
                earned
                isNew={badge.is_new}
                size="sm"
              />
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-400 text-center py-2">Ajoute ton premier élève pour gagner un badge.</p>
        )}

        {data.next_badge && (
          <div className="mt-4 pt-4 border-t border-slate-100 -mx-1">
            <NextBadgeGoal nextBadge={data.next_badge} categories={COACH_BADGE_CATEGORIES} />
          </div>
        )}
      </CardContent>
    </Card>
  );
}